import { useState } from 'react'
import { Box } from '@mui/material'
import styles from './index.module.scss'
import Table from './Table'
import Card from './Card'
import {
	acceptKazooInvitationUser,
	rejectKazooInvitationUser,
} from '../../../features/kazooEventSlice'
import { useDispatch, useSelector } from 'react-redux'
import { LeaveKazooPopup } from '../../popups/LeaveKazooPopup'

function CustomTabPanel(props) {
	const { children, value, index, ...other } = props

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`vendor-dashboard-tabpanel-${index}`}
			aria-labelledby={`vendor-dashboard-tab-${index}`}
			{...other}
		>
			{value === index && <Box>{children}</Box>}
		</div>
	)
}

export default function InnerTab({
	kazoos,
	isSidebarOpen,
	innerTab,
	searchQuery,
}) {
	const dispatch = useDispatch()

	const userId = useSelector((s) => s.auth.user._id)
	const [popupToggle, setPopupToggle] = useState(false)
	const [kazooId, setKazooId] = useState('')

	const togglePopup = () => setPopupToggle((prev) => !prev)

	const handleClick = (kazooId, status) => {
		if (!status)
			window.location.assign(`/wedding/wedding-dashboard/${kazooId}`)
	}

	const handleAcceptClick = (kazooId) => {
		dispatch(acceptKazooInvitationUser({ kazooId }))
	}

	const handleRejectClick = (id) => {
		setKazooId(id)
		togglePopup()
	}

	const filteredRows = kazoos.filter((kazoo) =>
		kazoo.kazooName
			?.toLowerCase()
			.includes(searchQuery.toLowerCase().trim())
	)

	return (
		<>
			<Box sx={{ width: '100%' }} className={styles.mainTabs}>
				<CustomTabPanel
					value={innerTab}
					index={1}
					className={styles.TaskTimeLineDataGrid}
				>
					<div>
						<Table
							rows={filteredRows}
							handleClick={handleClick}
							handleAcceptClick={handleAcceptClick}
							handleRejectClick={handleRejectClick}
						/>
					</div>
				</CustomTabPanel>
				<CustomTabPanel
					value={innerTab}
					index={0}
					className={styles.TaskTimeLineDataGrid}
				>
					<div
						className={`${styles.pageScreen} ${isSidebarOpen ? styles.sidebarExpand : ''}`}
					>
						{filteredRows.map((kazoo) => (
							<Card
								kazoo={kazoo}
								key={kazoo._id}
								handleClick={handleClick}
								handleAcceptClick={handleAcceptClick}
								handleRejectClick={handleRejectClick}
							/>
						))}
					</div>
				</CustomTabPanel>
			</Box>

			{popupToggle && (
				<LeaveKazooPopup
					popupToggle={popupToggle}
					userId={userId}
					kazooId={kazooId}
					clickHandler={togglePopup}
				/>
			)}
		</>
	)
}
